import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectChatState } from '../../../../store/app.selectors';

import { IWorkspace, WorkspaceFeatures } from '../../../../modules/chat/interfaces/IWorkspace';
import { loadChannels, selectWorkspace, setChannels } from '../../../../modules/chat/store/chat.actions';
import { AppStateWithChat, chatInitialState } from '../../../../modules/chat/store/chat.reducer';
import {
  setAllChannelsLoaded,
  setLoadingChannel,
  setLoadingChannels,
  setShowChannelsFilters,
  setShowScrollButton,
} from '../../../../modules/shared/store/ui.actions';
import { BaseComponent } from '../../../shared/components/base/base.component';
import { DealerSettingName } from '../../interfaces/IDealerSettings';
import { PermissionsService } from '../../services/permissions.service';

@Component({
  selector: 'ngx-workspace-drawer',
  templateUrl: './workspace-drawer.component.html',
  styleUrls: ['./workspace-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkspaceDrawerComponent extends BaseComponent {
  private store = inject(Store<AppStateWithChat>);
  private permissionsService = inject(PermissionsService);

  chat = toSignal(this.store.select(selectChatState), { initialValue: chatInitialState });
  selectedWorkSpace = computed(() => this.chat().selectedWorkSpace);
  workspaces = computed(() =>
    this.chat().workspaces.filter((workspace) => {
      return (
        !this.permissionsService.checkWorkspaceFeatures([WorkspaceFeatures.needCheckEnableTextConversations], workspace) ||
        (this.permissionsService.checkWorkspaceFeatures([WorkspaceFeatures.needCheckEnableTextConversations], workspace) &&
          this.permissionsService.checkDealerSetting(DealerSettingName.enableTextConversation))
      );
    })
  );

  onClick(workspace: IWorkspace) {
    if (this.selectedWorkSpace()?.id !== workspace.id) {
      this.store.dispatch(selectWorkspace({ selectedWorkspace: workspace }));
      this.store.dispatch(setShowChannelsFilters({ value: workspace.hasFiltersOpenByDefault }));
      this.store.dispatch(setShowScrollButton({ value: false }));
      this.store.dispatch(setChannels({ channels: [], concat: false }));
      this.store.dispatch(setAllChannelsLoaded({ value: false }));
      this.store.dispatch(setLoadingChannels({ value: true }));
      this.store.dispatch(setLoadingChannel({ value: true }));
      this.store.dispatch(
        loadChannels({
          autoSelectChannel: true,
          setLoading: true,
          concat: false,
        })
      );
    }
  }
}
